import React, { useState } from 'react'
import { NavigationContainer } from '@react-navigation/native'
import { createNativeStackNavigator } from '@react-navigation/native-stack'
import {
  ChevronLeftIcon,
  extendTheme,
  NativeBaseProvider,
  Pressable,
} from 'native-base'
import Colors from '../Constants/Colors'
import ImageMenu from '../Components/ImageMenu'
import { useTranslation } from 'react-i18next'
import * as Font from 'expo-font'
import AppLoading from 'expo-app-loading'
import { ppw } from '../Utils/LogUtil'
import { getDeviceLanguageCode } from '../Utils/LanguageUtil'
import AmmContainer from '../Containers/AmmContainer'
import { onBackPressed, openGlossary } from '../Utils'
import GachaContainer from '../Containers/GachaContainer'
import { View } from 'react-native'
import LoadingView from '../Components/LoadingView'

const getFontsAsync = async (languageCode: string) => {
  let fonts
  if (languageCode === 'ja') {
    fonts = {
      appFontRegular: require('../../assets/fonts/MeiryoUI-03.ttf'),
      appFontBold: require('../../assets/fonts/MeiryoUI-Bold-03.ttf'),
      appFontItalic: require('../../assets/fonts/MeiryoUI-Italic-04.ttf'),
    }
  } else {
    fonts = {
      appFontBold: require('../../assets/fonts/opensans_bold.ttf'),
      appFontItalic: require('../../assets/fonts/opensans_italic.ttf'),
      appFontRegular: require('../../assets/fonts/opensans_regular.ttf'),
    }
  }
  await Font.loadAsync(fonts)
}

const Stack = createNativeStackNavigator()

const ApplicationNavigator = () => {
  const { t } = useTranslation()
  const theme = extendTheme({
    fontConfig: {
      appFont: {
        100: {
          normal: 'appFontRegular',
          italic: 'appFontItalic',
          bold: 'appFontBold',
        },
        200: {
          normal: 'appFontRegular',
          italic: 'appFontItalic',
          bold: 'appFontBold',
        },
        300: {
          normal: 'appFontRegular',
          italic: 'appFontItalic',
          bold: 'appFontBold',
        },
        400: {
          normal: 'appFontRegular',
          italic: 'appFontItalic',
          bold: 'appFontBold',
        },
        500: {
          normal: 'appFontRegular',
          italic: 'appFontItalic',
          bold: 'appFontBold',
        },
        600: {
          normal: 'appFontRegular',
          italic: 'appFontItalic',
          bold: 'appFontBold',
        },
        700: {
          normal: 'appFontRegular',
          italic: 'appFontItalic',
          bold: 'appFontBold',
        },
        800: {
          normal: 'appFontRegular',
          italic: 'appFontItalic',
          bold: 'appFontBold',
        },
        900: {
          normal: 'appFontRegular',
          italic: 'appFontItalic',
          bold: 'appFontBold',
        },
      },
    },
    fonts: {
      heading: 'appFont',
      body: 'appFont',
      mono: 'appFont',
    },
    colors: {
      radioPrimary: {
        50: Colors.white,
        100: Colors.primaryColor,
        200: Colors.primaryColor,
        300: Colors.primaryColor,
        400: Colors.primaryColor,
        500: Colors.primaryColor,
        600: Colors.primaryColor,
        700: Colors.primaryColor,
        800: Colors.primaryColor,
        900: Colors.primaryColor,
      },
    },
    components: {
      Radio: {
        defaultProps: {
          colorScheme: 'radioPrimary',
        },
      },
    },
  })

  const [isFontsReady, setFontsReady] = useState(false)

  const loadFontAsync = async () => {
    await getFontsAsync(getDeviceLanguageCode())
  }

  if (!isFontsReady) {
    ppw('ApplicationNavigator().isFontsReady', isFontsReady)
    return (
      <NativeBaseProvider>
        <View
          style={{
            flex: 1,
            // backgroundColor: Colors.redError,
          }}
        >
          <LoadingView isOpen={true} />
          <AppLoading
            startAsync={loadFontAsync}
            onFinish={() => setFontsReady(true)}
            onError={() => {}}
          />
        </View>
      </NativeBaseProvider>
    )
  }

  return (
    <NativeBaseProvider theme={theme}>
      <NavigationContainer>
        <Stack.Navigator>
          {/*<Stack.Screen*/}
          {/*  name={t('Alcohol')}*/}
          {/*  component={AlcoholContainer}*/}
          {/*  options={{*/}
          {/*    headerTitleAlign: 'center',*/}
          {/*    headerRight: () => (*/}
          {/*      <ImageMenu*/}
          {/*        uri={*/}
          {/*          'https://s3.ap-northeast-1.amazonaws.com/real.genki.uploads/RN_Uploads/ic_bulb.png'*/}
          {/*        }*/}
          {/*      />*/}
          {/*    ),*/}
          {/*    headerTintColor: Colors.black,*/}
          {/*    headerLeft: () => (*/}
          {/*      <ArrowBackIcon size="5" mt="0.5" color={Colors.black} />*/}
          {/*    ),*/}
          {/*    navigationBarColor: 'white',*/}
          {/*    headerShadowVisible: false,*/}
          {/*    headerStyle: {*/}
          {/*      backgroundColor: 'white',*/}
          {/*    },*/}
          {/*  }}*/}
          {/*/>*/}
          {/*<Stack.Screen*/}
          {/*  name="DemoCalendarContainer"*/}
          {/*  component={DemoCalendarContainer}*/}
          {/*  options={{*/}
          {/*    headerTitleAlign: 'center',*/}
          {/*    headerRight: () => (*/}
          {/*      <ImageMenu*/}
          {/*        uri={*/}
          {/*          'https://s3.ap-northeast-1.amazonaws.com/real.genki.uploads/RN_Uploads/ic_bulb.png'*/}
          {/*        }*/}
          {/*      />*/}
          {/*    ),*/}
          {/*    headerTintColor: Colors.black,*/}
          {/*    headerLeft: () => (*/}
          {/*      <ArrowBackIcon size="5" mt="0.5" color={Colors.black} />*/}
          {/*    ),*/}
          {/*    navigationBarColor: 'white',*/}
          {/*    headerShadowVisible: false,*/}
          {/*    headerStyle: {*/}
          {/*      backgroundColor: 'white',*/}
          {/*    },*/}
          {/*  }}*/}
          {/*/>*/}
          <Stack.Screen
            name={t('Gacha')}
            component={GachaContainer}
            options={{
              navigationBarColor: 'white',
              headerTintColor: Colors.black,
              headerShadowVisible: false,
              headerStyle: {
                backgroundColor: 'white',
              },
              headerTitleStyle: {
                fontWeight: 'bold',
                fontSize: 20,
              },
              headerTitleAlign: 'center',
              headerLeft: () => (
                <Pressable
                  onPress={() => {
                    onBackPressed()
                  }}
                >
                  <ChevronLeftIcon
                    size="5"
                    mt="0.5"
                    marginLeft={4}
                    color={Colors.black}
                  />
                </Pressable>
              ),
              headerRight: () => (
                <Pressable
                  onPress={() => {
                    openGlossary('gacha')
                  }}
                >
                  <ImageMenu
                    mr={10}
                    uri={
                      'https://s3.ap-northeast-1.amazonaws.com/real.genki.uploads/RN_Uploads/ic_bulb.png'
                    }
                  />
                </Pressable>
              ),
            }}
          />
          {/*<Stack.Screen*/}
          {/*  name="RadarChartContainer"*/}
          {/*  component={DemoRadarChartContainer}*/}
          {/*/>*/}
          {/*<Stack.Screen*/}
          {/*  name="DemoSnapContainer"*/}
          {/*  component={DemoSnapContainer}*/}
          {/*/>*/}
          {/*<Stack.Screen*/}
          {/*  name={t('AMM')}*/}
          {/*  component={AmmContainer}*/}
          {/*  options={{*/}
          {/*    navigationBarColor: 'white',*/}
          {/*    headerShadowVisible: false,*/}
          {/*    headerStyle: {*/}
          {/*      backgroundColor: 'white',*/}
          {/*    },*/}
          {/*    headerTitleAlign: 'center',*/}
          {/*    headerTintColor: Colors.black,*/}
          {/*    headerTitleStyle: {*/}
          {/*      fontWeight: 'bold',*/}
          {/*      fontSize: 20,*/}
          {/*    },*/}
          {/*    headerLeft: () => (*/}
          {/*      <Pressable*/}
          {/*        onPress={() => {*/}
          {/*          onBackPressed()*/}
          {/*        }}*/}
          {/*      >*/}
          {/*        <ChevronLeftIcon*/}
          {/*          size="5"*/}
          {/*          marginLeft={4}*/}
          {/*          mt="0.5"*/}
          {/*          color={Colors.black}*/}
          {/*        />*/}
          {/*      </Pressable>*/}
          {/*    ),*/}
          {/*    headerRight: () => (*/}
          {/*      <Pressable*/}
          {/*        onPress={() => {*/}
          {/*          openGlossary('amm')*/}
          {/*        }}*/}
          {/*      >*/}
          {/*        <ImageMenu*/}
          {/*          mr={10}*/}
          {/*          uri={*/}
          {/*            'https://s3.ap-northeast-1.amazonaws.com/real.genki.uploads/RN_Uploads/ic_bulb.png'*/}
          {/*          }*/}
          {/*        />*/}
          {/*      </Pressable>*/}
          {/*    ),*/}
          {/*  }}*/}
          {/*/>*/}
          {/*<Stack.Screen name="HomeContainer" component={HomeContainer} />*/}
          {/*<Stack.Screen*/}
          {/*  name="DemoRtkQueryContainer"*/}
          {/*  component={DemoRtkQueryContainer}*/}
          {/*/>*/}
          {/*<Stack.Screen*/}
          {/*  name="DemoReduxContainer"*/}
          {/*  component={DemoReduxContainer}*/}
          {/*/>*/}
        </Stack.Navigator>
      </NavigationContainer>
    </NativeBaseProvider>
  )
}

export default ApplicationNavigator
